// extracted by mini-css-extract-plugin
export var box = "_49-0";
export var check = "_49-1";
export var checkboxButton = "_49-6";
export var checkboxGroup = "_49-5";
export var disabled = "_49-7";
export var ghost = "_49-9";
export var input = "_49-2";
export var label = "_49-4";
export var normal = "_49-8";
export var uncheck = "_49-3";